import React from 'react';
import { graphql, Link } from 'gatsby';
import paths from 'constants/paths';
import { Layout } from 'components/layout';
import { PageContext } from 'gatsby/internal';
import { Breadcrumb, Breadcrumbs } from 'components/breadcrumbs/breadcrumbs';
import { SEO } from 'components/seo';
import { createTopicsUrl } from 'helpers/utils';
import * as styles from './topics-from-a-to-z.module.scss';

type TopicsFromAToZProps = {
  pageContext: PageContext & {
    selected: string;
    allTags: {
      [letter: string]: {
        slug: string
        value: string;
      }[]
    }
  }
};

const TopicsFromAToZ = (props: TopicsFromAToZProps) => {
  const { pageContext } = props;
  const breadcrumbs: Breadcrumb[] = [
    { name: 'Home page', slug: '/' },
    { name: 'Dental Health A to Z', slug: '' },
  ];
  const fromAToZ = 'abcdefghijklmnopqrstuvwxyz'.split('');
  const leftSection = pageContext.allTags[pageContext.selected].slice(0, 25);
  const rightSection = pageContext.allTags[pageContext.selected].slice(26);

  return (
    <Layout>
      <div className={styles.genericContainer}>
        <Breadcrumbs breadcrumbs={breadcrumbs} className={styles.breadcrumb} />
        <div>
          <h1 className={styles.title}>Dental Health Topics from A to Z</h1>
          <div className={styles.linksSection}>
            {fromAToZ.map((l) => {
              const style = pageContext.allTags[l].length === 0 ? styles.empty : styles.linkOption;
              return <Link key={l} to={`${paths.dentalHealFromAToZ}/${l}`} className={l === pageContext.selected ? styles.selected : style}>{l}</Link>;
            })}
          </div>
          <h3 className={styles.listTitle}>{pageContext.selected}</h3>
          <div className={styles.listWrapper}>
            {leftSection.length > 0 ? (
              <>
                <div className={styles.column}>
                  {leftSection.map((i) => (
                    <Link
                      key={i.slug}
                      to={createTopicsUrl(i.slug)}
                      className={styles.topic}
                    >
                      {i.value}
                    </Link>
                  ))}
                </div>
                <div className={styles.column}>
                  {rightSection.map((i) => (
                    <Link
                      key={i.slug}
                      to={createTopicsUrl(i.slug)}
                      className={styles.topic}
                    >
                      {i.value}
                    </Link>
                  ))}
                </div>
              </>
            ) : 'No topics'}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default TopicsFromAToZ;

export const query = graphql`
  query {
    strapiSitewideSchema {
      dentalHealthAToZTitle
      dentalHealthAToZDescription
    }
  }
`;

type SEOType = {
  data: {
    strapiSitewideSchema: {
      dentalHealthAToZTitle: string
      dentalHealthAToZDescription: string
    }
  }
};

export const Head = ({ data, pageContext }: SEOType & TopicsFromAToZProps) => {
  const title = `${data.strapiSitewideSchema.dentalHealthAToZTitle} - Letter ${pageContext.selected}`;
  return (
    <SEO
      ogSlug={`/dental-health-A-to-Z/${pageContext.selected}`}
      description={data.strapiSitewideSchema.dentalHealthAToZDescription}
      title={title}
    />
  );
};
